// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"820671c5","189":"eafd9dcd","204":"b90744c3","277":"c7e73419","292":"c222ca2a","605":"deee6bab","641":"05c4c737","719":"1474aca2","724":"8d04334d","756":"31fc4b1c","768":"f808cb19"}[chunkId] + ".chunk.js";
};